/**
 * TONY ODISHO LANDING PAGE — Shopify JS Asset
 * File: assets/tony-odisho-landing.js
 */

document.addEventListener('DOMContentLoaded', function () {
  initTechCarousel();
  initVideoCarousel();
});

/* ===== TECH CAROUSEL ===== */
function initTechCarousel() {
  var track = document.getElementById('to-tech-track');
  var prevBtn = document.getElementById('to-tech-prev');
  var nextBtn = document.getElementById('to-tech-next');

  if (!track) return;

  function getScrollAmount() {
    var slide = track.querySelector('.to-tech-slide');
    if (!slide) return 300;
    return slide.offsetWidth + 24; // card width + gap
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }
}

/* ===== VIDEO CAROUSEL ===== */
function initVideoCarousel() {
  const track = document.getElementById('to-video-track');
  const prevBtn = document.getElementById('to-video-prev');
  const nextBtn = document.getElementById('to-video-next');

  if (!track) return;

  const SCROLL_AMOUNT = 320;

  function updateButtons() {
    if (prevBtn) prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.4' : '1';
    if (nextBtn) {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      nextBtn.style.opacity = atEnd ? '0.4' : '1';
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', updateButtons);
  updateButtons();

  // Pause other videos when one starts playing
  const videos = track.querySelectorAll('.to-video-player');
  videos.forEach(function (video) {
    video.addEventListener('play', function () {
      videos.forEach(function (v) {
        if (v !== video) v.pause();
      });
    });
  });
}
